import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../api/client";

export default function Login() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from || "/";

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.post("/auth/login", { password });
      navigate(from, { replace: true });
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 429) {
        setError("Too many failed attempts. Try again in 15 minutes.");
      } else if (status === 401) {
        setError("Invalid password.");
      } else {
        setError("Login failed. Try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bg)",
        padding: 24,
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          background: "var(--bg-card)",
          border: "1px solid var(--border)",
          borderRadius: "var(--radius-lg)",
          boxShadow: "var(--shadow-md)",
          padding: 32,
          width: "100%",
          maxWidth: 380,
        }}
      >
        <h1
          style={{
            fontFamily: "Fraunces, serif",
            fontSize: 24,
            fontWeight: 600,
            marginBottom: 6,
          }}
        >
          MOT Admin
        </h1>
        <div
          style={{
            fontSize: 13,
            color: "var(--text-secondary)",
            marginBottom: 24,
          }}
        >
          Sign in to continue
        </div>

        <label
          style={{
            display: "block",
            fontSize: 12,
            color: "var(--text-secondary)",
            marginBottom: 6,
          }}
        >
          Password
        </label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
          required
          style={{
            width: "100%",
            padding: "10px 12px",
            borderRadius: "var(--radius)",
            border: "1px solid var(--border)",
            fontSize: 14,
            marginBottom: 16,
            background: "var(--bg-card)",
            color: "var(--text-primary)",
          }}
        />

        {error && (
          <div
            style={{
              background: "var(--red-light)",
              color: "var(--red-text)",
              padding: "8px 12px",
              borderRadius: "var(--radius)",
              fontSize: 13,
              marginBottom: 16,
            }}
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px 12px",
            background: "var(--accent)",
            color: "#fff",
            border: "none",
            borderRadius: "var(--radius)",
            fontSize: 14,
            fontWeight: 500,
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
